import { gql } from '@apollo/client';

const CommissionOnboardingQuery = gql`
  query CommissionOnboarding {
    commissionOnboarding {
      items {
        price
        state
        type
      }
      product
      type
    }
  }
`;

export default CommissionOnboardingQuery;
